import { Chip, TableCell } from '@mui/material'
import React from 'react'
import { i18n } from '../index'
import { TODAY_HIGHLIGHT_COLOR } from './util'

function getDisplayedText(schedules: { opens: string; closes: string }[] | null): string {
  if (schedules?.every((schedule) => schedule.opens === '00:00' && schedule.closes === '00:00')) {
    return i18n.t('restaurantMenu.closed')
  }
  if (schedules?.every((schedule) => schedule.opens === '00:00' && schedule.closes === '23:59')) {
    return i18n.t('restaurantMenu.alwaysOpen')
  }
  return `${schedules?.map((schedule) => `${schedule.opens}-${schedule.closes}`).join('\n') ?? ''}`
}

interface TimeCellProps {
  schedules: { opens: string; closes: string }[] | null
  isExceptional: boolean
  isToday: boolean
  isDefaultTime: boolean
}

export default function TimeCell({ schedules, isExceptional, isToday, isDefaultTime }: TimeCellProps) {
  const isClosed = schedules?.every((schedule) => schedule.opens === '00:00' && schedule.closes === '00:00')
  const cellBackgroundColor = isToday ? TODAY_HIGHLIGHT_COLOR : undefined
  const textStyle = isDefaultTime ? { fontStyle: 'italic' } : { fontStyle: 'normal' }
  const displayedText = getDisplayedText(schedules)
  if (isExceptional) {
    return (
      <TableCell style={{ whiteSpace: 'pre-line', backgroundColor: cellBackgroundColor, ...textStyle }}>
        <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'pre-line',
            },
          }}
          size='small'
          color='info'
          label={displayedText}
        />
      </TableCell>
    )
  }
  if (isClosed) {
    return (
      <TableCell style={{ backgroundColor: cellBackgroundColor, ...textStyle }}>
        <Chip size='small' color='warning' label={displayedText} />
      </TableCell>
    )
  }
  return (
    <TableCell style={{ whiteSpace: 'pre-line', backgroundColor: cellBackgroundColor, ...textStyle }}>
      {displayedText}
    </TableCell>
  )
}
